import { Component, Injector, OnInit } from '@angular/core';
import * as moment from '@node_modules/moment-timezone';
import { finalize } from '@node_modules/rxjs/operators';
import { StringUtils } from '@shared/helpers/StringUtils';
import { PagedListingComponentBase, PagedRequestDto } from '@shared/paged-listing-component-base';
import { ArquivoServiceProxy, PacienteDto, PacienteServiceProxy, PrescricaoDto, PrescricaoServiceProxy, TipoPrescricaoDto } from '@shared/service-proxies/service-proxies';
import { TipoPrescricaoValues } from "@shared/model/tipo-prescricao-enum.model";
import { ActivatedRoute } from '@node_modules/@angular/router';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import * as FileSaver from 'file-saver';
import { ProntuarioService } from '@shared/services/prontuario.service';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { AppSessionService } from '@shared/session/app-session.service';
import { SelecionarDependenteDialogComponent } from '@app/meus-arquivos/selecionar-dependente-dialog/selecionar-dependente-dialog.component';

export class PagedPrescricaoRequestDto extends PagedRequestDto {
  public dataFim: moment.Moment;
  public dataInicio: moment.Moment;
  public pacienteId: string;
  public cidId: string;
  public procedimentoTussId: string;
  public procedimentoSigtapId: string;
  public medicamentoTissId: string;
  public medicamentoSigtapId: string;
  public profissionalId: string;
  public clinicaId: string;
}

@Component({
  selector: 'app-default-prescricoes',
  templateUrl: './default-prescricoes.component.html',
  styleUrls: ['./default-prescricoes.component.scss'],
  animations: [appModuleAnimation()]
})
export class DefaultPrescricoesComponent extends PagedListingComponentBase<PrescricaoDto> implements OnInit {

  protected dataInicio: string;
  protected dataFim: string;
  protected request: PagedPrescricaoRequestDto = new PagedPrescricaoRequestDto();
  protected prescricoes: PrescricaoDto[] = [];
  protected tipoPrescricaoCid: TipoPrescricaoDto[] = []
  protected tipoPrescricaoMedicamentoSigtap: TipoPrescricaoDto[] = []
  protected tipoPrescricaoMedicamentoTiss: TipoPrescricaoDto[] = []
  protected tipoPrescricaoProcedimentoSigtap: TipoPrescricaoDto[] = []
  protected tipoPrescricaoProcedimentoTuss: TipoPrescricaoDto[] = []
  pacienteAtual: PacienteDto;
  pacienteInicial: PacienteDto;
  pacienteId: string;
  dependentes: PacienteDto[] = [];

  constructor(
    injector: Injector,
    private readonly _prescricaoService: PrescricaoServiceProxy,
    private _appSessionService: AppSessionService,
    private readonly _arquivoService: ArquivoServiceProxy,
    private readonly _prontuarioService: ProntuarioService,
    private readonly route: ActivatedRoute,
    private readonly _pacienteServiceProxy: PacienteServiceProxy,
    private _modalService: BsModalService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.request.pacienteId = id ?? this.appSession.pacienteId;
      this.pacienteId = id ?? this.appSession.pacienteId;
      if (id) {
        this.request.profissionalId = this.appSession.profissionalId;
        if (this.appSession.clinicaId) {
          this.request.clinicaId = this.appSession.clinicaId;
        } else if (this.appSession.profissionalId != this._prontuarioService.getId()) {
          this.request.clinicaId = this._prontuarioService.getId();
        }
      }
      this.getTiposPrescricoes();
      this.getPaciente();
      this.refresh();
    });
  }

  getPaciente() {
    this._pacienteServiceProxy.getPacienteByUserId(this._appSessionService.userId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((paciente) => {
      this.pacienteAtual = paciente;
      this.pacienteInicial = paciente;
      if (paciente.cpf) {
        this.getDependentes(paciente.cpf);
      }
    })
  }

  getDependentes(cpf: string) {
      abp.ui.setBusy()
      this._pacienteServiceProxy.getDependentes(cpf).pipe(
        finalize(() => {
          abp.ui.clearBusy();
        })
      ).subscribe((dependentes) => {
        this.dependentes = dependentes;
      })
    }
  
    selecionarDependentes() {
      const selecionarDependenteDialog: BsModalRef = this._modalService.show(
        SelecionarDependenteDialogComponent,
        {
          class: 'modal-md',
          backdrop: 'static',
          keyboard: false,
          initialState: {
            dependentes: this.dependentes
          }
        }
      );
  
      selecionarDependenteDialog.content.onSelect.subscribe((id) => {
        this.pacienteAtual = this.dependentes.find(x => x.id === id);
        this.pacienteId = id;
        this.request.pacienteId = this.pacienteId;
        this.refresh();
      });
    }
  
    voltarParaPacienteInicial() {
      this.pacienteAtual = this.pacienteInicial;
      this.pacienteId = this.pacienteInicial.id;
      this.request.pacienteId = this.pacienteId;
      this.refresh();
    }

  protected list(request: PagedPrescricaoRequestDto, pageNumber: number, finishedCallback: Function): void {
    abp.ui.setBusy();
    request.clinicaId = this.request.clinicaId;
    request.pacienteId = this.request.pacienteId
    request.profissionalId = this.request.profissionalId;

    request.dataFim = StringUtils.isNullOrEmpty(this.dataFim) ? undefined : moment(this.dataFim)
    request.dataInicio = StringUtils.isNullOrEmpty(this.dataInicio) ? undefined : moment(this.dataInicio)
    request.cidId = this.request.cidId;
    request.procedimentoSigtapId = this.request.procedimentoSigtapId;
    request.procedimentoTussId = this.request.procedimentoTussId;
    request.medicamentoSigtapId = this.request.medicamentoSigtapId;
    request.medicamentoTissId = this.request.medicamentoTissId;

    this._prescricaoService.getPrescricao(
      request.clinicaId,
      request.profissionalId,
      request.pacienteId,
      request.cidId,
      request.procedimentoTussId,
      request.procedimentoSigtapId,
      request.medicamentoTissId,
      request.medicamentoSigtapId,
      request.dataInicio,
      request.dataFim,
      request.skipCount,
      request.maxResultCount
    ).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.prescricoes = result.items;
      this.totalItems = result.totalCount;
      this.showPaging(result, pageNumber);
    });
  }

  protected delete(entity: PrescricaoDto): void {
    throw new Error('Method not implemented.');
  }

  protected download(arquivo: PrescricaoDto) {
    this._arquivoService.getTemporaryLink(arquivo.urlArquivo)
      .pipe(
        finalize(() => {
        })
      )
      .subscribe(async x => {
        await fetch(x).then(r => {
          r.blob().then(aux => {
            FileSaver.saveAs(aux, `${arquivo.nomeArquivo}.${arquivo.extensaoArquivo}`);
            abp.ui.clearBusy();
          })
        });
      });
  }

  private getTiposPrescricoes(): void {
    abp.ui.setBusy();
    this._prescricaoService.getNomePescricoes(this.request.pacienteId, this.request.clinicaId, this.request.profissionalId).pipe(
      finalize(() => {
        abp.ui.clearBusy();
      })
    ).subscribe((result) => {
      this.tipoPrescricaoCid = result.filter(x => x.tipo == TipoPrescricaoValues.Cid);
      this.tipoPrescricaoMedicamentoSigtap = result.filter(x => x.tipo == TipoPrescricaoValues.MedicamentoSigtap);
      this.tipoPrescricaoMedicamentoTiss = result.filter(x => x.tipo == TipoPrescricaoValues.MedicamentoTiss);
      this.tipoPrescricaoProcedimentoSigtap = result.filter(x => x.tipo == TipoPrescricaoValues.ProcedimentoSigtap);
      this.tipoPrescricaoProcedimentoTuss = result.filter(x => x.tipo == TipoPrescricaoValues.ProcedimentoTuss);
    });
  }

  protected limparFiltros(): void {
    this.request.cidId = null;
    this.request.procedimentoSigtapId = null;
    this.request.procedimentoTussId = null;
    this.request.medicamentoSigtapId = null;
    this.request.medicamentoTissId = null;
    this.dataFim = undefined;
    this.dataInicio = undefined
    this.refresh()
  }
}
